module.exports = __webpack_public_path__ + "img/home-expert.3b5155e1.png";